'use strict';

function get(lang) {
  return require(`../assets/locale/messages_${lang}.json`);
}

export {get};



// WEBPACK FOOTER //
// ./modules/locale.js